export const DEPLOYMENT_FIX_WITH_AI_CONTRACT_ID = 'deployment_fix_with_ai_v1';

export const DEPLOYMENT_FIX_WITH_AI_PROMPT =
  'Fix this failed scheduled deployment with AI. Diagnose it from authoritative deployment status, logs, and saved code. If a safe strategy revision can recover it now, save and read back that revision and prepare an update for this same deployment; do not create another deployment or reconnect the broker.';

export const DEPLOYMENT_FIX_WITH_AI_PROMPT_SHA256 =
  '62838106eae11ceaf2dbc2722afefc9b91db44ad1d45524ba93c91b591577975';

type DeploymentRecoveryContextInput = {
  deploymentId: string | null;
  runId: string | null;
  status: string | null;
  healthCategory: string | null;
  healthReason: string | null;
  error: string | null;
};

export function buildDeploymentFixWithAiContext(input: DeploymentRecoveryContextInput) {
  return {
    externalEvent: {
      externalKind: 'deployment',
      eventName: 'deployment.status_changed',
      status: 'failed',
      previousStatus: input.status,
      isTerminal: true,
      externalId: input.deploymentId,
      payload: {
        deploymentId: input.deploymentId,
        runId: input.runId,
        healthCategory: input.healthCategory,
        healthReason: input.healthReason,
        error: input.error,
      },
    },
    workflowContext: {
      wakeReason: 'owner_fix_with_ai',
      expectedAction: 'inspect_logs_fix_code_prepare_existing_deployment_update',
      recoveryContractId: DEPLOYMENT_FIX_WITH_AI_CONTRACT_ID,
      promptSha256: DEPLOYMENT_FIX_WITH_AI_PROMPT_SHA256,
    },
  };
}
